/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $(window).on("load", function() {
          console.log('all');
          jQuery.each(PinchZoomer.objs, function( index, value ) {
            PinchZoomer.objs[index].resetElem();
            console.log(index);
          });
        });

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // About us page, note the change from about-us to about_us.
    'search': {
      init: function() {


        },
        finalize: function() {
          $('.seach-result').slick({
            dots: false,
            arrows: true,
            adaptiveHeight: false,
            speed: 500
          });
        //   if(noSearch){
        //     $('.seach-result').slick({
        //       dots: false,
        //       arrows: true,
        //       adaptiveHeight: false,
        //       speed: 500
        //     });
        //   }else{
        //     $('.seach-result').slick({
        //       dots: true,
        //       arrows: false,
        //       adaptiveHeight: false,
        //       speed: 500
        //     });
        // }
      }

    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);


  $( window ).resize(function() {
    $('.dropdown-menu-main').css('max-height', window.innerHeight-128 + "px");
  });

  // if(window.innerWidth>989){
  //   $( window ).resize(function() {
  //     $('body.professional .content-info').css('margin-top', window.innerHeight-950 + "px");
  //   });
  //   $('body.professional .content-info').css('margin-top', window.innerHeight-950 + "px");
  //
  // }
$(window).on("load", function() {
  var home_slide = $('#home-slider').slick({
    dots: true,
    arrows: false,
    // adaptiveHeight: true,
    speed: 500,
    // autoplay: true,
    // autoplaySpeed: 37000,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          adaptiveHeight: false
        }
      },
      {
        breakpoint: 900,
        settings: {
          adaptiveHeight: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          adaptiveHeight: false
        }
      }
    ]
  });

  if(window.innerWidth<768){
    $('#banner-mobile').on('load', function(){
        // $(this).show();
        console.log('load the iframe');
        home_slide.slick('slickSetOption', 'autoplaySpeed', 42000);
        $('#home-slider').slick('slickPlay');



        var tid = setTimeout(mycode, 500);
        function mycode() {
            $('.cover-banner-mobile').addClass('remove');
          clearTimeout(tid);
        }
    });

  }
  if(window.innerWidth>=768 && window.innerWidth<1200){
    $('#banner-ipad').on('load', function(){
        // $(this).show();
        console.log('load the iframe');
        home_slide.slick('slickSetOption', 'autoplaySpeed', 42000);
        $('#home-slider').slick('slickPlay');

        var tid = setTimeout(mycode, 500);
        function mycode() {
          $('.cover-banner-ipad').addClass('remove');
          clearTimeout(tid);
        }

    });

  }
  if(window.innerWidth>=1200){
    $('#banner-desk').on('load', function(){
        // $(this).show();
        console.log('load the iframe');
        home_slide.slick('slickSetOption', 'autoplaySpeed', 42000);
        $('#home-slider').slick('slickPlay');

        var tid = setTimeout(mycode, 500);
        function mycode() {
          $('.cover-banner-desk').addClass('remove');
          clearTimeout(tid);
        }
    });
  }


  $('#home-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    console.log(nextSlide);
    if(nextSlide==0){
      $('#banner-desk').attr('src', $('#banner-desk').attr('src'));
      $('#banner-ipad').attr('src', $('#banner-ipad').attr('src'));
      $('#banner-mobile').attr('src', $('#banner-mobile').attr('src'));
      home_slide.slick('slickSetOption', 'autoplaySpeed', 42000);
    }else{
      home_slide.slick('slickSetOption', 'autoplaySpeed', 5000);
      $('.cover-banner-desk').removeClass('remove');
      $('.cover-banner-ipad').removeClass('remove');
      $('.cover-banner-mobile').removeClass('remove');
    }
    $('#home-slider').slick('slickPlay');
    // console.log(jQuery('#home-slider').slick('slickGetOption', 'autoplaySpeed'));
  });



});

  jQuery('.promotion-img').css('max-height', window.innerHeight-50);

  $('#news-slider').slick({
    dots: true,
    arrows: false,
    adaptiveHeight: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  if (typeof _home_count == 'undefined'){
    _home_count=3;
  }
  $('#news-slider-2').slick({
    dots: true,
    arrows: false,
    adaptiveHeight: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: _home_count,
          slidesToScroll: _home_count,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });


  $('.sigle-content-slider').slick({
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    speed: 500,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
  $('.general-side').slick({
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    speed: 500
  });
  $('.home-plan-side').slick({
      dots: true,
      arrows: false,
      adaptiveHeight: true,
      speed: 500,
      responsive: [
        {
          breakpoint: 2000,
          settings: {
            dots: false,
            arrows: true
          }
        },
        {
          breakpoint: 900,
          settings: {
            dots: true,
            arrows: false
          }
        }
      ]
  });



  $('.seach-result-3').slick({
    dots: false,
    arrows: true,
    adaptiveHeight: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3
  });

  $('[data-submenu]').submenupicker();

  $('#input_1_3').attr('maxlength',10);
  $('#input_2_2').attr('maxlength',10);

  if (typeof(banner_popup) !== "undefined"){
    window.lightbox = lity('#inline');
  }
  if (typeof(register_popup) !== "undefined"){
    window.lightbox2 = lity('#inline2');
  }

  jQuery( document ).on( "keyup",'.gfield_error input, .gfield_error textarea', function() {
    jQuery(this).parent().parent().removeClass('gfield_error');
  });

  jQuery('.clear-search').click(function(){
  	jQuery('.selected-form').html('');
  	//jQuery('input').removeAttr('CHECKED');
  	jQuery('input').prop('checked', false);
  });


  var on1 = false;
  $('#home-photo-1').on('show.bs.modal', function (e) {
    if(!on1){
      on1 = true;
      $("#home-photo-1 img").pinchzoomer();
    }
  })


  $(window).on("load", function() {
    $(".modal").on('shown.bs.modal', function (e) {
      jQuery.each(PinchZoomer.objs, function( index, value ) {
        PinchZoomer.objs[index].resetElem();
        console.log(index);
      });

    });
  });

  $(window).on('resize', function() {
    jQuery.each(PinchZoomer.objs, function( index, value ) {
        PinchZoomer.objs[index].resetElem();
        console.log(index);
      });
      jQuery('.home-slider').slick('setPosition');

  });


$(window).on('orientationchange', function() {
  jQuery.each(PinchZoomer.objs, function( index, value ) {
      PinchZoomer.objs[index].resetElem();
      console.log(index);
    });
    jQuery('.home-slider').slick('setPosition');
});

})(jQuery); // Fully reference jQuery after this point.
